/**
 * BORKI - Asistente Oficial Borkify
 * Chat widget self-contained: CSS + HTML + Logic
 * Version 1.0 | borkify.es
 */
(function(){
  window._BORKI_CSS  = "\n/* \n   BORKI CHAT WIDGET - Borkify Official Assistant\n   Mobile-First | Brand Colors\n    */\n\n/*  LAUNCHER BUBBLE  */\n#borki-launcher {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  width: 62px;\n  height: 62px;\n  border-radius: 50%;\n  background: #29ABE2;\n  box-shadow: 0 6px 24px rgba(41,171,226,.45);\n  border: none;\n  cursor: pointer;\n  z-index: 99990;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform .25s cubic-bezier(.34,1.56,.64,1), box-shadow .2s;\n  outline: none;\n}\n#borki-launcher:hover {\n  transform: scale(1.12);\n  box-shadow: 0 10px 32px rgba(41,171,226,.55);\n}\n#borki-launcher.open { transform: rotate(90deg) scale(1.05); }\n#borki-launcher img  { width: 38px; height: 38px; border-radius: 50%; pointer-events: none; }\n\n/* Badge de notificacion */\n#borki-badge {\n  position: absolute;\n  top: -2px; right: -2px;\n  width: 20px; height: 20px;\n  background: #29ABE2;\n  color: #fff;\n  border-radius: 50%;\n  font-size: 11px;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid #fff;\n  animation: borkiPulse 1.8s ease-in-out infinite;\n}\n@keyframes borkiPulse {\n  0%,100% { box-shadow: 0 0 0 0 rgba(41,171,226,.5); }\n  50%      { box-shadow: 0 0 0 8px rgba(41,171,226,0); }\n}\n\n/*  CHAT MODAL  */\n#borki-modal {\n  position: fixed;\n  bottom: 100px;\n  right: 24px;\n  width: 360px;\n  max-width: calc(100vw - 32px);\n  height: 520px;\n  max-height: calc(100vh - 120px);\n  background: #fff;\n  border-radius: 22px;\n  box-shadow: 0 16px 60px rgba(0,0,0,.22);\n  z-index: 99989;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  transform: scale(.85) translateY(20px);\n  opacity: 0;\n  pointer-events: none;\n  transition: transform .3s cubic-bezier(.34,1.56,.64,1), opacity .25s ease;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n#borki-modal.open {\n  transform: scale(1) translateY(0);\n  opacity: 1;\n  pointer-events: all;\n}\n\n/* Header */\n#borki-header {\n  background: linear-gradient(135deg, #1A1A2E 0%, #2d2d4e 100%);\n  padding: 14px 16px;\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  flex-shrink: 0;\n}\n#borki-header-avatar {\n  width: 40px; height: 40px;\n  border-radius: 50%;\n  border: 2.5px solid #29ABE2;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n#borki-header-info { flex: 1; min-width: 0; }\n#borki-header-name {\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1.2;\n}\n#borki-header-status {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  color: #aaa;\n}\n.borki-online-dot {\n  width: 7px; height: 7px;\n  border-radius: 50%;\n  background: #22C55E;\n  animation: borkiPulse 2s ease-in-out infinite;\n}\n#borki-close-btn {\n  background: rgba(255,255,255,.1);\n  border: none;\n  color: #fff;\n  width: 28px; height: 28px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background .2s;\n}\n#borki-close-btn:hover { background: rgba(255,255,255,.2); }\n\n/* Mensajes */\n#borki-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 14px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  background: #F9F7F5;\n  scroll-behavior: smooth;\n}\n#borki-messages::-webkit-scrollbar { width: 4px; }\n#borki-messages::-webkit-scrollbar-thumb { background: #ddd; border-radius: 4px; }\n\n/* Burbujas de mensaje */\n.borki-msg {\n  display: flex;\n  align-items: flex-end;\n  gap: 6px;\n  max-width: 88%;\n  animation: borkiMsgIn .25s ease-out;\n}\n@keyframes borkiMsgIn {\n  from { opacity:0; transform: translateY(8px); }\n  to   { opacity:1; transform: translateY(0); }\n}\n.borki-msg.bot  { align-self: flex-start; }\n.borki-msg.user { align-self: flex-end; flex-direction: row-reverse; }\n\n.borki-msg-avatar {\n  width: 28px; height: 28px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n  margin-bottom: 2px;\n}\n.borki-bubble {\n  padding: 10px 13px;\n  border-radius: 16px;\n  font-size: 13.5px;\n  line-height: 1.5;\n  max-width: 100%;\n  word-break: break-word;\n}\n.borki-msg.bot  .borki-bubble {\n  background: #fff;\n  color: #1A1A2E;\n  border-bottom-left-radius: 4px;\n  box-shadow: 0 1px 4px rgba(0,0,0,.08);\n}\n.borki-msg.user .borki-bubble {\n  background: #29ABE2;\n  color: #fff;\n  border-bottom-right-radius: 4px;\n}\n.borki-bubble a { color: #29ABE2; text-decoration: underline; }\n\n/* Typing indicator */\n.borki-typing {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 0;\n}\n.borki-typing-dots {\n  display: flex;\n  gap: 4px;\n  background: #fff;\n  padding: 10px 14px;\n  border-radius: 16px;\n  border-bottom-left-radius: 4px;\n  box-shadow: 0 1px 4px rgba(0,0,0,.08);\n}\n.borki-typing-dots span {\n  width: 7px; height: 7px;\n  background: #ccc;\n  border-radius: 50%;\n  animation: borkiDot 1.2s ease-in-out infinite;\n}\n.borki-typing-dots span:nth-child(2) { animation-delay: .2s; }\n.borki-typing-dots span:nth-child(3) { animation-delay: .4s; }\n@keyframes borkiDot {\n  0%,80%,100% { transform: scale(1); background: #ccc; }\n  40%         { transform: scale(1.3); background: #29ABE2; }\n}\n\n/* Quick replies */\n#borki-quickreplies {\n  padding: 8px 12px 6px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  background: #F9F7F5;\n  flex-shrink: 0;\n}\n.borki-qr {\n  background: #fff;\n  border: 1.5px solid #29ABE2;\n  color: #29ABE2;\n  border-radius: 20px;\n  padding: 5px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all .18s;\n  white-space: nowrap;\n}\n.borki-qr:hover {\n  background: #29ABE2;\n  color: #fff;\n}\n\n/* Input area */\n#borki-input-area {\n  padding: 10px 12px;\n  border-top: 1px solid #eee;\n  display: flex;\n  gap: 8px;\n  align-items: flex-end;\n  background: #fff;\n  flex-shrink: 0;\n}\n#borki-input {\n  flex: 1;\n  border: 1.5px solid #e5e5e5;\n  border-radius: 20px;\n  padding: 9px 14px;\n  font-size: 13.5px;\n  outline: none;\n  resize: none;\n  min-height: 38px;\n  max-height: 90px;\n  line-height: 1.4;\n  font-family: inherit;\n  transition: border-color .2s;\n}\n#borki-input:focus { border-color: #29ABE2; }\n#borki-input::placeholder { color: #bbb; }\n#borki-send {\n  width: 38px; height: 38px;\n  border-radius: 50%;\n  background: #29ABE2;\n  border: none;\n  color: #fff;\n  font-size: 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: background .2s, transform .15s;\n}\n#borki-send:hover { background: #1a96cc; transform: scale(1.08); }\n#borki-send:disabled { background: #ddd; cursor: default; transform: none; }\n\n/* Email capture form */\n#borki-email-form {\n  padding: 12px;\n  background: #FFF8F0;\n  border-top: 1px solid #FFD6B3;\n  display: none;\n  flex-direction: column;\n  gap: 8px;\n  flex-shrink: 0;\n}\n#borki-email-form.visible { display: flex; }\n#borki-email-form p {\n  font-size: 12px;\n  color: #888;\n  margin: 0;\n  line-height: 1.4;\n}\n#borki-email-input {\n  border: 1.5px solid #FFD6B3;\n  border-radius: 10px;\n  padding: 8px 12px;\n  font-size: 13px;\n  outline: none;\n  font-family: inherit;\n}\n#borki-email-input:focus { border-color: #29ABE2; }\n#borki-email-submit {\n  background: #29ABE2;\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  padding: 9px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n/* Powered by */\n#borki-footer {\n  text-align: center;\n  padding: 5px 0 8px;\n  font-size: 10px;\n  color: #ccc;\n  background: #fff;\n  flex-shrink: 0;\n}\n#borki-footer a { color: #29ABE2; text-decoration: none; }\n\n/* Mobile */\n@media (max-width: 480px) {\n  #borki-modal {\n    bottom: 0; right: 0;\n    width: 100vw;\n    max-width: 100vw;\n    height: 100dvh;\n    max-height: 100dvh;\n    border-radius: 20px 20px 0 0;\n  }\n  #borki-launcher { bottom: 16px; right: 16px; }\n}\n";
  window._BORKI_HTML = "\n<!-- \n     BORKI - Asistente oficial Borkify\n      -->\n\n<!-- LAUNCHER BUBBLE -->\n<button id=\"borki-launcher\" aria-label=\"Abrir chat con Borki\" title=\"Hola! Soy Borki, tu asistente perruno\">\n  <img src=\"https://cdn.shopify.com/s/files/1/1049/0458/9653/files/borki-avatar-v2.png?v=1779663252\" alt=\"Borki\">\n  <span id=\"borki-badge\" aria-hidden=\"true\">1</span>\n</button>\n\n<!-- CHAT MODAL -->\n<div id=\"borki-modal\" role=\"dialog\" aria-modal=\"true\" aria-label=\"Chat con Borki - Asistente Borkify\">\n\n  <!-- Header -->\n  <div id=\"borki-header\">\n    <img id=\"borki-header-avatar\"\n      src=\"https://cdn.shopify.com/s/files/1/1049/0458/9653/files/borki-avatar-v2.png?v=1779663252\"\n      alt=\"Borki avatar\">\n    <div id=\"borki-header-info\">\n      <div id=\"borki-header-name\">Borki </div>\n      <div id=\"borki-header-status\">\n        <span class=\"borki-online-dot\"></span>\n        <span>Asistente de Borkify  En linea</span>\n      </div>\n    </div>\n    <button id=\"borki-close-btn\" aria-label=\"Cerrar chat\" onclick=\"borkiClose()\">x</button>\n  </div>\n\n  <!-- Messages -->\n  <div id=\"borki-messages\" role=\"log\" aria-live=\"polite\">\n    <!-- Messages injected by JS -->\n  </div>\n\n  <!-- Quick replies -->\n  <div id=\"borki-quickreplies\" aria-label=\"Respuestas rapidas\"></div>\n\n  <!-- Email capture (visible cuando necesario) -->\n  <div id=\"borki-email-form\">\n    <p>Dejame tu correo y un humano de nuestro equipo te responde enseguida:</p>\n    <input type=\"email\" id=\"borki-email-input\" placeholder=\"tuemail@ejemplo.com\" autocomplete=\"email\">\n    <button id=\"borki-email-submit\" onclick=\"borkiSubmitEmail()\">Enviar correo</button>\n  </div>\n\n  <!-- Input area -->\n  <div id=\"borki-input-area\">\n    <textarea id=\"borki-input\"\n      placeholder=\"Escribe aqui...\"\n      rows=\"1\"\n      aria-label=\"Escribe tu mensaje\"\n      onkeydown=\"borkiKeyDown(event)\"\n      oninput=\"borkiAutoResize(this)\">\n    </textarea>\n    <button id=\"borki-send\" onclick=\"borkiSend()\" aria-label=\"Enviar mensaje\">\n      &#10148;\n    </button>\n  </div>\n\n  <!-- Footer -->\n  <div id=\"borki-footer\">Asistente de <a href=\"/\">Borkify</a>  Hecho con </div>\n\n</div>\n";
})();

(function() {
'use strict';

// -- CONFIGURACION ----------------------------------
var BORKI_CONFIG = {
  storeName:       'Borkify',
  supportEmail:    'info@borkify.es',
  shippingFree:    '35',        // euros para envio gratis
  shippingDays:    '24-48 horas laborables',
  returnDays:      14,
  typingDelay:     900,         // ms de "escribiendo..." antes de respuesta
  openOnLoad:      false,       // abrir automaticamente al entrar
  openDelay:       4000,        // ms hasta auto-abrir (si openOnLoad=true)
  welcomeOnFirst:  true,        // mostrar burbuja de bienvenida al primer visit
  avatarUrl: 'https://cdn.shopify.com/s/files/1/1049/0458/9653/files/borki-avatar-v2.png?v=1779663252',
};

// -- ESTADO INTERNO ---------------------------------
var BORKI_STATE = {
  open:         false,
  initialized:  false,
  awaitingOrder: false,
  awaitingEmail: false,
  awaitingDogSize: false,
  pendingContext: null,
  sessionMessages: [],
};

// -- BASE DE CONOCIMIENTO: QUICK REPLIES POR CONTEXTO --
var BORKI_QR = {
  default: [
    { label: 'Donde esta mi pedido', intent: 'order_status' },
    { label: 'Cuanto tarda el envio', intent: 'shipping' },
    { label: 'Quiero devolver algo', intent: 'returns' },
    { label: 'Ayudame a elegir', intent: 'recommend' },
  ],
  shipping: [
    { label: 'Envio a Peninsula', intent: 'shipping_peninsula' },
    { label: 'Envio a Canarias/Baleares', intent: 'shipping_islands' },
    { label: 'Volver al menu', intent: 'menu' },
  ],
  returns: [
    { label: 'Producto defectuoso', intent: 'defective' },
    { label: 'Quiero devolver', intent: 'return_request' },
    { label: 'Cambiar por otro', intent: 'exchange' },
    { label: 'Volver al menu', intent: 'menu' },
  ],
  recommend: [
    { label: 'Perro pequeno (< 10 kg)', intent: 'rec_small' },
    { label: 'Perro mediano (10-25 kg)', intent: 'rec_medium' },
    { label: 'Perro grande (> 25 kg)', intent: 'rec_large' },
    { label: 'Volver al menu', intent: 'menu' },
  ],
  after_resolve: [
    { label: 'Tengo otra pregunta', intent: 'menu' },
    { label: 'Hablar con un humano', intent: 'human' },
  ],
};

// -- RESPUESTAS POR INTENCION ------------------------
var BORKI_RESPONSES = {

  welcome: [
    'iHola! Soy Borki, el asistente oficial de Borkify. Estoy aqui para ayudarte con lo que necesites. En que puedo echarte una pata hoy? ',
  ],

  menu: [
    'Por supuesto! En que puedo ayudarte? Elige una opcion o escribe tu pregunta directamente.',
  ],

  order_status: [
    'iClaro! Para localizar tu pedido necesito dos datos rapidos: tu numero de pedido (lo encuentras en el email de confirmacion, empieza por #) y el correo con el que compraste. Con eso lo tenemos localizado en segundos. ',
  ],

  order_received_id: [
    'Perfecto, lo tengo apuntado. Ahora indcame el correo con el que realizaste la compra y lo compruebo enseguida.',
  ],

  order_found: [
    'Genial, lo tengo todo. Una vez enviado debiste recibir un email con el enlace de seguimiento del transportista. iRevisa tambien la carpeta de spam! Si no lo encuentras, un humano de nuestro equipo te lo reenva ahora mismo. Quieres que te ponga en contacto con ellos?',
  ],

  shipping: [
    'iEnviamos a toda Espana! Elige tu zona y te cuento los detalles:',
  ],

  shipping_peninsula: [
    'Para Espana Peninsular el plazo es de 24-48 horas laborables  Y el envio es completamente gratis a partir de ' + BORKI_CONFIG.shippingFree + 'EUR. Por debajo de esa cantidad se calcula en la pantalla de pago segun el transportista.',
  ],

  shipping_islands: [
    'Para Baleares, Canarias, Ceuta y Melilla el plazo es de 3 a 5 dias laborables. El coste de envio se calcula automaticamente en la pantalla de pago segun el peso y destino. iSin sorpresas!',
  ],

  returns: [
    'iAqui estamos para ayudarte! Cuentame que ha pasado:',
  ],

  return_request: [
    'Sin problema. Tienes ' + BORKI_CONFIG.returnDays + ' dias naturales desde que recibes el producto para solicitar la devolucion. El articulo debe estar en su embalaje original y sin haber sido usado. Para gestionar la devolucion necesito tu numero de pedido y correo. Puedes escribirlos aqui o contactar directamente con nuestro equipo.',
  ],

  exchange: [
    'iPor supuesto! Los cambios funcionan igual que las devoluciones: tienes ' + BORKI_CONFIG.returnDays + ' dias desde la recepcion, producto sin usar y en su embalaje. Indcame tu numero de pedido y correo y te gestiono el cambio.',
  ],

  defective: [
    'iVaya, lo sentimos de verdad! Eso no deberia haber pasado y lo vamos a solucionar ahora mismo. Por favor indcame tu numero de pedido y tu correo y nuestro equipo te gestiona un reemplazo gratuito sin que tengas que devolver nada. ',
  ],

  recommend: [
    'iMe encanta ayudar! Para recomendarte lo mejor, solo necesito saber el tamano de tu peludo:',
  ],

  rec_small: [
    'Para perros pequeos (hasta 10 kg) nuestros juguetes dispensadores de golosinas en tamano S son perfectos: son de materiales seguros, estimulan la mente y aguantan bien los mordiscos de los mas chiquitines. iTu perro los va a adorar! Quieres que te lleve directamente al catalogo?',
  ],

  rec_medium: [
    'Para perros medianos (10-25 kg) los dispensadores de golosinas de tamano M y los mordedores resistentes son el hit del momento en Borkify. Son durables, divertidos y perfectos para mantenerlos entretenidos. iEchales un vistazo en nuestro catalogo!',
  ],

  rec_large: [
    'Para perros grandes (mas de 25 kg) necesitamos materiales extra-resistentes! Nuestros juguetes tamano L estan disenados para los mordelones mas aplicados. iNo los rompen ni con ganas!  Te llevo al catalogo?',
  ],

  human: [
    'iClaro! Nuestro equipo humano esta listo para ayudarte. Dejame tu correo y te respondemos en menos de 24 horas (normalmente mucho antes ).',
  ],

  escalate: [
    'Para darte el dato exacto, prefiero que lo consulte un humano del equipo. Dejame tu correo aqui mismo o escrbenos a ' + BORKI_CONFIG.supportEmail + ' y te respondemos volando.',
  ],

  fallback: [
    'Hmm, eso se me escapa un poco  Pero no te preocupes! Puedo ayudarte con envios, pedidos, devoluciones y recomendaciones. O si prefieres, te pongo en contacto con nuestro equipo humano.',
    'No estoy seguro de haber entendido bien tu pregunta. iCuentame mas o elige una opcion y te ayudo!',
  ],

  email_request: [
    'iPerfecto! Dejame tu correo electronico y un humano del equipo te contactara enseguida:',
  ],

  email_received: [
    'iAnotado! En breve un miembro de nuestro equipo se pondra en contacto contigo. iGracias por tu paciencia, lo resolvemos juntos! ',
  ],

  greeting: [
    'iHola! Me alegra verte por aqui. En que te puedo ayudar hoy? ',
    'iWoof! Hola! Soy Borki, el asistente de Borkify. iCuntame que necesitas!',
  ],

  thanks: [
    'iDe nada! Para eso estamos. Si necesitas algo mas, aqui me tienes. iHasta la proxima y muchos wags para tu peludo! ',
    'iUn placer ayudarte! Si surge cualquier duda, ya sabes donde encontrarme. ',
  ],

  bye: [
    'iHasta pronto! Gracias por confiar en Borkify. iTu perro tiene buen gusto! ',
  ],
};


// -- DETECCION DE INTENCION (NLU simple) ------------
function borkiDetectIntent(text) {
  var t = text.toLowerCase()
    .replace(/[aeiou]/g, function(c) {
      return {a:'a',e:'e',i:'i',o:'o',u:'u',
              '':'a','':'e','':'i','':'o','':'u',
              '':'u','':'n'}[c] || c;
    })
    .trim();

  // Saludo
  if (/^(hola|buenas|hey|saludos|ola|hello|hi |buen dia|buen tarde)/.test(t)) return 'greeting';

  // Agradecimiento
  if (/(gracias|muchas gracias|ty|thank|perfecto gracias|ok gracias|genial gracias)/.test(t)) return 'thanks';

  // Despedida
  if (/^(adios|bye|hasta luego|chao|nos vemos|ciao)/.test(t)) return 'bye';

  // Pedido / estado
  if (/(donde.*ped|estado.*ped|mi ped|seguimiento|tracking|llegado|entrega|ped.*[0-9]|#[0-9])/.test(t)) return 'order_status';
  if (/^#?[0-9]{3,8}$/.test(t.replace(/ /g,''))) return 'order_id_provided';

  // Envio
  if (/(envio|envia|enviar|shipping|tarda|plazo|cuando llega|entrega|portes|gastos envio|envio gratis)/.test(t)) return 'shipping';
  if (/(peninsula|peninsular|madrid|barcelona|espana peninsu)/.test(t)) return 'shipping_peninsula';
  if (/(canaria|balear|ceuta|melilla|isla)/.test(t)) return 'shipping_islands';

  // Devolucion / cambio
  if (/(devol|cambio|cambiar|reembolso|refund|devolver|cambiar|no me gusta|talla|equivocad)/.test(t)) return 'returns';
  if (/(roto|defectuoso|lleg mal|lleg roto|daado|mal estado|no funciona|averiado)/.test(t)) return 'defective';

  // Recomendacion
  if (/(que.*compro|recomienda|ayuda.*elegir|mejor.*para|cual.*mejor|que.*regalo|suger|consejo)/.test(t)) return 'recommend';
  if (/(pequen|chihuahua|yorkshire|pomerania|toy|mini|nano)/.test(t)) return 'rec_small';
  if (/(mediano|border|cocker|beagle|buldog|boxer|schnauzer)/.test(t)) return 'rec_medium';
  if (/(grande|pastor|labrador|golden|dogo|husky|san bernardo|dobermann|gran)/.test(t)) return 'rec_large';

  // Humano
  if (/(humano|persona|hablar.*persona|agente|atencion|soporte|ayuda.*real)/.test(t)) return 'human';

  // Email detectado en mensaje
  if (/[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}/.test(t)) return 'email_provided';

  return 'fallback';
}

// -- UI: ANADIR MENSAJE AL CHAT ----------------------
function borkiAddMessage(text, type) {
  var msgs = document.getElementById('borki-messages');
  if (!msgs) return;

  var div = document.createElement('div');
  div.className = 'borki-msg ' + (type || 'bot');

  var html = '';
  if (type === 'bot' || !type) {
    html += '<img class="borki-msg-avatar" src="' + BORKI_CONFIG.avatarUrl + '" alt="Borki">';
  }
  html += '<div class="borki-bubble">' + borkiEscape(text) + '</div>';
  div.innerHTML = html;
  msgs.appendChild(div);
  msgs.scrollTop = msgs.scrollHeight;
  BORKI_STATE.sessionMessages.push({ role: type || 'bot', text: text });
}

// -- UI: TYPING INDICATOR ---------------------------
function borkiShowTyping() {
  var msgs = document.getElementById('borki-messages');
  if (!msgs) return;
  var div = document.createElement('div');
  div.className = 'borki-msg bot borki-typing-wrap';
  div.id = 'borki-typing';
  div.innerHTML =
    '<img class="borki-msg-avatar" src="' + BORKI_CONFIG.avatarUrl + '" alt="Borki">' +
    '<div class="borki-typing-dots">' +
    '<span></span><span></span><span></span>' +
    '</div>';
  msgs.appendChild(div);
  msgs.scrollTop = msgs.scrollHeight;
}
function borkiHideTyping() {
  var el = document.getElementById('borki-typing');
  if (el) el.remove();
}

// -- UI: QUICK REPLIES ------------------------------
function borkiSetQR(context) {
  var qrEl = document.getElementById('borki-quickreplies');
  if (!qrEl) return;
  var items = BORKI_QR[context] || BORKI_QR['default'];
  qrEl.innerHTML = items.map(function(qr) {
    return '<button class="borki-qr" onclick="borkiHandleQR(' + "'" + qr.intent + "'" + ')">' + qr.label + '</button>';
  }).join('');
}

// -- RESPUESTA DEL BOT ------------------------------
function borkiBotReply(intentOrText, qrContext) {
  borkiShowTyping();
  setTimeout(function() {
    borkiHideTyping();
    var responses = BORKI_RESPONSES[intentOrText];
    var text = responses
      ? responses[Math.floor(Math.random() * responses.length)]
      : intentOrText;
    borkiAddMessage(text, 'bot');
    if (qrContext) borkiSetQR(qrContext);
    else borkiSetQR('after_resolve');
  }, BORKI_CONFIG.typingDelay);
}

// -- LOGICA PRINCIPAL DE RESPUESTA -----------------
function borkiProcessMessage(userText) {
  var text = userText.trim();
  if (!text) return;

  borkiAddMessage(text, 'user');
  var input = document.getElementById('borki-input');
  if (input) { input.value = ''; input.style.height = 'auto'; }

  // Modo espera de numero de pedido
  if (BORKI_STATE.awaitingOrder) {
    BORKI_STATE.awaitingOrder = false;
    BORKI_STATE.pendingContext = 'order';
    borkiBotReply('order_received_id', null);
    setTimeout(function() { borkiBotReply('order_found', 'after_resolve'); }, 1800);
    return;
  }

  // Modo espera de email
  if (BORKI_STATE.awaitingEmail) {
    var emailMatch = text.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}/);
    if (emailMatch) {
      BORKI_STATE.awaitingEmail = false;
      borkiShowEmailForm(false);
      borkiBotReply('email_received', 'after_resolve');
    } else {
      borkiBotReply('Por favor, introduce un correo valido para que podamos contactarte.', 'after_resolve');
    }
    return;
  }

  var intent = borkiDetectIntent(text);

  switch(intent) {
    case 'greeting':
      borkiBotReply('greeting', 'default');
      break;
    case 'thanks':
      borkiBotReply('thanks', null);
      borkiSetQR('after_resolve');
      break;
    case 'bye':
      borkiBotReply('bye', null);
      break;
    case 'order_status':
      BORKI_STATE.awaitingOrder = true;
      borkiBotReply('order_status', null);
      break;
    case 'order_id_provided':
      BORKI_STATE.pendingContext = 'order';
      borkiBotReply('order_received_id', null);
      setTimeout(function() { borkiBotReply('order_found', 'after_resolve'); }, 1600);
      break;
    case 'email_provided':
      borkiShowEmailForm(false);
      borkiBotReply('email_received', 'after_resolve');
      break;
    case 'shipping':
      borkiBotReply('shipping', 'shipping');
      break;
    case 'shipping_peninsula':
      borkiBotReply('shipping_peninsula', 'after_resolve');
      break;
    case 'shipping_islands':
      borkiBotReply('shipping_islands', 'after_resolve');
      break;
    case 'returns':
      borkiBotReply('returns', 'returns');
      break;
    case 'defective':
      borkiBotReply('defective', null);
      borkiSetQR('after_resolve');
      break;
    case 'return_request':
      borkiBotReply('return_request', 'after_resolve');
      break;
    case 'exchange':
      borkiBotReply('exchange', 'after_resolve');
      break;
    case 'recommend':
      borkiBotReply('recommend', 'recommend');
      break;
    case 'rec_small':
      borkiBotReply('rec_small', 'after_resolve');
      break;
    case 'rec_medium':
      borkiBotReply('rec_medium', 'after_resolve');
      break;
    case 'rec_large':
      borkiBotReply('rec_large', 'after_resolve');
      break;
    case 'human':
      BORKI_STATE.awaitingEmail = true;
      borkiBotReply('human', null);
      setTimeout(function() { borkiShowEmailForm(true); }, BORKI_CONFIG.typingDelay + 300);
      break;
    default:
      borkiBotReply('fallback', 'default');
  }
}

// -- MANEJAR QUICK REPLIES --------------------------
window.borkiHandleQR = function(intent) {
  var labels = {};
  Object.values(BORKI_QR).forEach(function(arr) {
    arr.forEach(function(qr) { labels[qr.intent] = qr.label; });
  });
  var label = labels[intent] || intent;
  borkiAddMessage(label, 'user');

  switch(intent) {
    case 'menu':        borkiBotReply('menu', 'default'); break;
    case 'order_status': BORKI_STATE.awaitingOrder = true; borkiBotReply('order_status', null); break;
    case 'shipping':     borkiBotReply('shipping', 'shipping'); break;
    case 'shipping_peninsula': borkiBotReply('shipping_peninsula', 'after_resolve'); break;
    case 'shipping_islands':   borkiBotReply('shipping_islands', 'after_resolve'); break;
    case 'returns':      borkiBotReply('returns', 'returns'); break;
    case 'return_request': borkiBotReply('return_request', 'after_resolve'); break;
    case 'exchange':     borkiBotReply('exchange', 'after_resolve'); break;
    case 'defective':    borkiBotReply('defective', 'after_resolve'); break;
    case 'recommend':    borkiBotReply('recommend', 'recommend'); break;
    case 'rec_small':    borkiBotReply('rec_small', 'after_resolve'); break;
    case 'rec_medium':   borkiBotReply('rec_medium', 'after_resolve'); break;
    case 'rec_large':    borkiBotReply('rec_large', 'after_resolve'); break;
    case 'human':
      BORKI_STATE.awaitingEmail = true;
      borkiBotReply('human', null);
      setTimeout(function() { borkiShowEmailForm(true); }, BORKI_CONFIG.typingDelay + 300);
      break;
    default: borkiBotReply('fallback', 'default');
  }
};

// -- EMAIL FORM -------------------------------------
function borkiShowEmailForm(show) {
  var form = document.getElementById('borki-email-form');
  if (!form) return;
  if (show) form.classList.add('visible');
  else form.classList.remove('visible');
}

window.borkiSubmitEmail = function() {
  var emailEl = document.getElementById('borki-email-input');
  if (!emailEl) return;
  var email = emailEl.value.trim();
  if (!email || !/^[^s@]+@[^s@]+.[^s@]+$/.test(email)) {
    emailEl.style.borderColor = '#29ABE2';
    return;
  }
  borkiShowEmailForm(false);
  borkiAddMessage(email, 'user');
  borkiBotReply('email_received', 'after_resolve');
  emailEl.value = '';
};

// -- HELPERS UI -------------------------------------
function borkiEscape(str) {
  return String(str)
    .replace(/&/g,'&amp;')
    .replace(/</g,'&lt;')
    .replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;');
}

window.borkiKeyDown = function(e) {
  if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); borkiSend(); }
};

window.borkiAutoResize = function(el) {
  el.style.height = 'auto';
  el.style.height = Math.min(el.scrollHeight, 90) + 'px';
};

window.borkiSend = function() {
  var input = document.getElementById('borki-input');
  if (!input || !input.value.trim()) return;
  borkiProcessMessage(input.value);
};

// -- ABRIR / CERRAR ----------------------------------
window.borkiOpen = function() {
  var modal   = document.getElementById('borki-modal');
  var launcher = document.getElementById('borki-launcher');
  var badge   = document.getElementById('borki-badge');
  if (!modal) return;
  BORKI_STATE.open = true;
  modal.classList.add('open');
  launcher.classList.add('open');
  if (badge) badge.style.display = 'none';
  var input = document.getElementById('borki-input');
  if (input) setTimeout(function() { input.focus(); }, 350);
  // Welcome message on first open
  if (!BORKI_STATE.initialized) {
    BORKI_STATE.initialized = true;
    borkiShowTyping();
    setTimeout(function() {
      borkiHideTyping();
      borkiAddMessage(BORKI_RESPONSES.welcome[0], 'bot');
      borkiSetQR('default');
    }, 800);
  }
};

window.borkiClose = function() {
  var modal    = document.getElementById('borki-modal');
  var launcher = document.getElementById('borki-launcher');
  if (!modal) return;
  BORKI_STATE.open = false;
  modal.classList.remove('open');
  if (launcher) launcher.classList.remove('open');
};

window.borkiToggle = function() {
  BORKI_STATE.open ? borkiClose() : borkiOpen();
};

// -- INICIALIZACION ----------------------------------
function borkiInit() {
  // Inyectar CSS
  var style = document.createElement('style');
  style.id = 'borki-styles';
  style.textContent = window._BORKI_CSS || '';
  document.head.appendChild(style);

  // Inyectar HTML
  var container = document.createElement('div');
  container.id = 'borki-root';
  container.innerHTML = window._BORKI_HTML || '';
  document.body.appendChild(container);

  // Launcher click
  var launcher = document.getElementById('borki-launcher');
  if (launcher) launcher.addEventListener('click', borkiToggle);

  // Cerrar con Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && BORKI_STATE.open) borkiClose();
  });

  // Auto open?
  if (BORKI_CONFIG.openOnLoad) {
    setTimeout(borkiOpen, BORKI_CONFIG.openDelay);
  }

  // Badge de bienvenida (solo primera visita por sesion)
  var badge = document.getElementById('borki-badge');
  if (badge && !sessionStorage.getItem('borki_seen')) {
    badge.style.display = 'flex';
    sessionStorage.setItem('borki_seen', '1');
  } else if (badge) {
    badge.style.display = 'none';
  }

  console.log('[Borki] Asistente Borkify inicializado OK');
}

// Esperar a que el DOM este listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', borkiInit);
} else {
  setTimeout(borkiInit, 100);
}

})(); // END BORKI IIFE
